import React from "react";
import Index from "../components/examSchedule";
import CandidateLayout from "../layouts/candidateLayout/layout";

function ExamSchedules() {
  return (
    <>
       <CandidateLayout>
        <Index />
       </CandidateLayout>
       
    </>
  );
}

export default ExamSchedules;